// extracted by mini-css-extract-plugin
export default {"selectedBtn":"styles_selectedBtn__urSxI","unselectedBtn":"styles_unselectedBtn__EVZ5W","sqButton":"styles_sqButton__zhVhE"};